import type { Company } from '@xing-com/crate-common-graphql-types';

import type { TopCompany } from '../types';

export const createTopCompany = (item: Company): TopCompany => ({
  id: item.id,
  hasOpenJobs: true,
  jobsCount: item.jobsCount && item.jobsCount > 0 ? item.jobsCount : undefined,
  name: item.companyName ?? '',
  size: item.companySize ?? undefined,
  companyUrl: item.links?.public ?? undefined,
  jobsUrl: item.links?.public ? `${item.links.public}/jobs` : undefined,
  industry: item.industry?.localizationValue,
  location: item.address?.city ?? undefined,
  profileImageUri: item.logos?.logo128px ?? undefined,
});

export const createTopCompanies = (items: Company[]): TopCompany[] =>
  items.map(createTopCompany);
